import type { OnResizePayload, OnDragPayload, SectionsData } from './types';

export const ON_DRAG = 'ON_DRAG';
export const ON_DRAG_START = 'ON_DRAG_START';
export const ON_DRAG_END = 'ON_DRAG_END';
export const ON_LENGTH_CHANGE = 'ON_LENGTH_CHANGE';
export const ON_RESIZE = 'ON_RESIZE';
export const SAVE_PREDRAG_WIDTHS = 'SAVE_PREDRAG_WIDTHS';
export const SET_ACTIVE_SEPARATOR = 'SET_ACTIVE_SEPARATOR';
export const SET_IS_HOVERED = 'SET_IS_HOVERED';
export const SET_ONBOARDING_WIDTH = 'SET_ONBOARDING_WIDTH';

export type OnDragAction = {
	type: typeof ON_DRAG;
	payload: OnDragPayload;
};

export type OnDragStartAction = {
	type: typeof ON_DRAG_START;
	payload: string;
};

export type OnDragEndAction = {
	type: typeof ON_DRAG_END;
	payload: string;
};

export type OnLengthChangeAction = {
	type: typeof ON_LENGTH_CHANGE;
	payload: OnResizePayload;
};

export type OnResizeAction = {
	type: typeof ON_RESIZE;
	payload: OnResizePayload;
};

export type OnSavePredragWidthsAction = {
	type: typeof SAVE_PREDRAG_WIDTHS;
	id: string;
	sectionId: string;
};

export type OnSetActiveSeparatorAction = {
	type: typeof SET_ACTIVE_SEPARATOR;
	id: string;
	index: number | null | undefined;
};

export type OnSetIsHovered = {
	type: typeof SET_IS_HOVERED;
	id: string;
	index: number | null | undefined;
};

export type OnSetOnboardingWidthAction = {
	type: typeof SET_ONBOARDING_WIDTH;
	id: string;
	sectionsData: SectionsData;
	width: number | undefined;
};

export type Action =
	| OnDragAction
	| OnDragStartAction
	| OnDragEndAction
	| OnLengthChangeAction
	| OnResizeAction
	| OnSavePredragWidthsAction
	| OnSetActiveSeparatorAction
	| OnSetIsHovered
	| OnSetOnboardingWidthAction;

export type Dispatch = (action: Action) => void;

export const onResize = (payload: OnResizePayload): OnResizeAction => ({
	type: ON_RESIZE,
	payload,
});

export const onDrag = (payload: OnDragPayload): OnDragAction => ({
	type: ON_DRAG,
	payload,
});

export const onSetOnboardingWidth = (
	id: string,
	sectionsData: SectionsData,
	width: number | undefined,
): OnSetOnboardingWidthAction => ({
	type: SET_ONBOARDING_WIDTH,
	sectionsData,
	id,
	width,
});

export const onSavePredragWidths = (id: string, sectionId: string): OnSavePredragWidthsAction => ({
	type: SAVE_PREDRAG_WIDTHS,
	id,
	sectionId,
});

export const onLengthChange = (payload: OnResizePayload): OnLengthChangeAction => ({
	type: ON_LENGTH_CHANGE,
	payload,
});
